import type { ParsedAttributeQuery } from '../types'

import { foldSearchText } from './foldSearchText'

/**
 * Operators (phase 1 — attribute full-text):
 * - Spaces → AND between tokens (each token must match).
 * - `"phrase"` → exact substring match (case-insensitive).
 * - `-word` → exclusion (haystack must not contain `word`).
 */
export function parseAttributeQuery(raw: string): ParsedAttributeQuery {
  const trimmed = raw.trim()
  if (!trimmed) {
    return { mustInclude: [], mustExclude: [], phrases: [] }
  }

  const tokens: string[] = []
  let i = 0

  while (i < trimmed.length) {
    while (i < trimmed.length && /\s/.test(trimmed[i])) i += 1
    if (i >= trimmed.length) break

    if (trimmed[i] === '"') {
      const end = trimmed.indexOf('"', i + 1)
      if (end === -1) {
        tokens.push(trimmed.slice(i))
        break
      }
      tokens.push(trimmed.slice(i, end + 1))
      i = end + 1
      continue
    }

    let j = i
    while (j < trimmed.length && !/\s/.test(trimmed[j])) j += 1
    tokens.push(trimmed.slice(i, j))
    i = j
  }

  const mustInclude: string[] = []
  const mustExclude: string[] = []
  const phrases: string[] = []

  for (const tok of tokens) {
    if (!tok) continue
    if (tok.startsWith('"') && tok.endsWith('"') && tok.length >= 2) {
      phrases.push(foldSearchText(tok.slice(1, -1)))
      continue
    }
    if (tok.startsWith('-') && tok.length > 1) {
      mustExclude.push(foldSearchText(tok.slice(1)))
      continue
    }
    mustInclude.push(foldSearchText(tok))
  }

  return { mustInclude, mustExclude, phrases }
}

export function hasPositiveTerms(parsed: ParsedAttributeQuery): boolean {
  return parsed.mustInclude.length > 0 || parsed.phrases.length > 0
}
